module.exports = __webpack_public_path__ + "static/media/adventure.adeef8b4.jpg";